const ticket = {
  labels: {
    team: "Soporte Técnico",
    new: "Nuevos",
    resolved: "Resueltos",
    cancelled: "Cancelados",
    waitingOnCustomerFeedback: "En espera de Retroalimentación del Usuario",
    duplicated: "Duplicados",
    inProgress: "En Progreso",
    other: "Otros",
    addNewComment: "Agregar nuevo commentario",
    createANewTicket: "Crear un Nuevo Ticket",
    subject: "Asunto",
    label: "Etiqueta",
    selectLabel: "Por favor seleccione una etiqueta",
    published: "Publicados el ",
    relatedEquipment: "Equipo Relacionado",
    notAnEquipment: "Ninguno",
    description: "Descripción",
    yourTickets: "Sus Tickets",
    issues: "Ticket de Software",
    mechanicalSupport: "Ticket de Hardware",
    suggestions: "Sugerencias",
    ticketProfile: "Detalles del Ticket",
    status: "Estatus",
    comments: "Comentarios",
    comment: "Comentario"
  },
  messages: {
    successful: "Ticket creado satisfactoriamente",
    commentMinError: "El comentario debe ser de 5 caracteres como minimo",
    commentNullError: "El comentario no debe estar vacío"
  },
  buttons: {
    backbtn: "Atrás",
    submit: "Enviar",
    confirm: "confirmar",
    modulesbtn: "Módulos"
  }
};

export default ticket;
